export default __webpack_public_path__ + "static/media/logo-v2.eba9214b.png";